import { render, staticRenderFns } from "./BonusSettings.vue?vue&type=template&id=396963b0"
import script from "./BonusSettings.vue?vue&type=script&lang=js"
export * from "./BonusSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports